import {
  GridCellProps,
  GridColumnMenuCheckboxFilter,
  GridColumnMenuProps,
} from "@progress/kendo-react-grid";
import { EnumerationCell } from "../../../Layout/Grid/Cell/Default/EnumCell";
import { ttProtectionStateAsString, TTProtectionStringValue } from "../TTProtectionState";

export const ttProtectionStateEnumCell = (props: GridCellProps) => (
  <EnumerationCell {...props} mapping={ttProtectionStateAsString} />
);

export const ttProtectionStateColumnMenu = (props: GridColumnMenuProps) => (
  <GridColumnMenuCheckboxFilter
    expanded
    filterable
    data={[
      { Status: TTProtectionStringValue.Active },
      { Status: TTProtectionStringValue.Updated },
      { Status: TTProtectionStringValue.Expired },
    ]}
    searchBox={() => null}
    {...props}
  />
);
